import {
  BaseText,
  EBaseTextPosition,
  EBaseTextSize,
  EBaseTextWeight,
} from '@spinwise/react-component-library/BaseText';
import { EBrandTextColor } from 'Libraries/typography.library';
import styles from './CountryBlock.module.scss';
import ActionCardSmall from '../../shared/cards/blocks/ActionCardSmall/ActionCardSmall';
import BrandIcon, { BrandIcons, BrandIconsSizes, ShapeColors, StatusIcons } from '../../shared/BrandIcon/BrandIcon';
import { t } from 'i18next';

export interface ICountryBlock {
  geo?: any;
}

const CountryBlock = ({ geo }: ICountryBlock) => {
  return (
    <div className={`d-fl ${styles.country_block_page_container}`}>
      <div className={`d-fl ai-c fl-d-c ${styles.country_block_page_container_image_box}`}>
        <div className={styles.country_block_page_container_elements}>
          <div className={`d-fl ai-c jc-c ${styles.country_block_logo_container}`}>
            <img src={'/images/logo.png'} alt="Winnerz.com" />
          </div>
          <div className={styles.country_block_title_country_container}>
            <div className={styles.country_block_title}>
              <span>{t('country.block.title')}</span>
            </div>
            <div className={`d-fl fl-d-c ai-c ${styles.country_block_country_container}`}>
              <span>{geo?.country}</span>
              <p className={styles.country_block_ip_address}>{geo?.ip}</p>
            </div>
          </div>
        </div>
      </div>
      <div className={`d-fl jc-fe ai-c fl-d-c ${styles.country_block_page_container_description_box}`}>
        <div className={`d-fl jc-c ai-c fl-d-c ${styles.country_block_page_container_description_box_small}`}>
          <div>
            <BrandIcon
              iconPath={BrandIcons.AccountSad}
              iconSize={BrandIconsSizes.Medium}
              shapeColor={ShapeColors.Default}
              statusPath={StatusIcons.None}
            />
          </div>
          <div className={`d-fl jc-se ai-c fl-d-c ${styles.description_text_small}`}>
            <BaseText
              weight={EBaseTextWeight.W600}
              value={t('country.block.not.in.restricted.region.title')}
              size={EBaseTextSize.Large}
              color={EBrandTextColor.Black}
              alignment={EBaseTextPosition.Center}
            ></BaseText>
            <BaseText
              weight={EBaseTextWeight.W400}
              value={t('country.block.not.in.restricted.region.subtitle')}
              size={EBaseTextSize.Regular}
              color={EBrandTextColor.Black06}
              alignment={EBaseTextPosition.Center}
            ></BaseText>
          </div>
          <div className={`d-fl jc-sb fl-d-c ${styles.country_block_page_buttons_container}`}>
            <ActionCardSmall
              key={1}
              id={'id1'}
              title={t('country.block.support.subtitle')}
              subtitle={t('support.email.label')}
              imgUrl={BrandIcons.Support}
              link={t('brand.support.mailto.link')}
              iconColor={ShapeColors.Default}
            />
            <ActionCardSmall
              key={2}
              id={'id2'}
              title={t('country.block.affiliate.subtitle')}
              subtitle={t('country.block.affiliate.label')}
              imgUrl={BrandIcons.Gift}
              link={t('spinwise.affiliates.url')}
              iconColor={ShapeColors.Attention}
            />
          </div>
        </div>
        <div className={`w-100 d-fl jc-sb ${styles.desktop_footer_copyright}`}>
          <span className={styles.desktop_footer_copyright_product}></span>
          <span className={styles.desktop_footer_copyright_brand}>{t('footer.brand.all.rights.reserved')}</span>
        </div>
      </div>
      <div className={styles.mobile_footer_block}>
        <div className={`w-100 d-fl jc-se ai-c fl-d-c ${styles.mobile_footer_copyright}`}>
          <span className={styles.mobile_footer_copyright_brand}>{t('footer.brand.all.rights.reserved')}</span>
          <span className={styles.mobile_footer_copyright_product}></span>
        </div>
      </div>
    </div>
  );
};

export default CountryBlock;
